import React from "react";
import { Box, Grid, Group, Text, Title } from "@mantine/core";

export const TypographyStylesheet = () => (
  <>
    <Title order={2} variant={"primary"} mb={"md"}>
      Typography
    </Title>

    {/* Note: the same color variants apply to DWText and DWTitle */}
    <Title order={1}>Title 1</Title>
    <Title order={2}>Title 2</Title>
    <Title order={3}>Title 3</Title>
    <Text size={"xl"}>Extra Large Text</Text>
    <Text size={"lg"}>Large Text</Text>
    <Text>Regular Text</Text>
    <Text size={"sm"}>Small Text</Text>
    <Text size={"xs"}>Extra Small Text</Text>
    <Text fs={"italic"}>Italic Text</Text>
    <Text fw={700}>Bold Text</Text>
    <Text variant={"link"}>Link = underline on hover</Text>

    <Grid mb={"xl"} py={"lg"}>
      <Grid.Col span={12}>
        <Title order={2} mb={"md"}>
          Text colors
        </Title>
        <Group wrap="wrap">
          <Text fw={700} variant={"green"}>
            Green
          </Text>
          <Text fw={700} variant={"lemon"}>
            Lemon
          </Text>
          <Text fw={700} variant={"tangerine"}>
            Tangerine
          </Text>
          <Text fw={700} variant={"carrot"}>
            Carrot
          </Text>
          <Text fw={700} variant={"flamingo"}>
            Flamingo
          </Text>
          <Text fw={700} variant={"orchid"}>
            Orchid
          </Text>
          <Text fw={700} variant={"sky"}>
            Sky
          </Text>
          <Text fw={700} variant={"grey"}>
            Grey
          </Text>
          <Text fw={700} variant={"green-light"}>
            Green Light
          </Text>
          <Text fw={700} variant={"lemon-light"}>
            Lemon Light
          </Text>
          <Text fw={700} variant={"tangerine-light"}>
            Tangerine Light
          </Text>
          <Text fw={700} variant={"carrot-light"}>
            Carrot Light
          </Text>
          <Text fw={700} variant={"flamingo-light"}>
            Flamingo Light
          </Text>
          <Text fw={700} variant={"orchid-light"}>
            Orchid Light
          </Text>
          <Text fw={700} variant={"sky-light"}>
            Sky Light
          </Text>
          <Text fw={700} variant={"green-dark"}>
            Green Dark
          </Text>
          <Text fw={700} variant={"lemon-dark"}>
            Lemon Dark
          </Text>
          <Text fw={700} variant={"tangerine-dark"}>
            Tangerine Dark
          </Text>
          <Text fw={700} variant={"carrot-dark"}>
            Carrot Dark
          </Text>
          <Text fw={700} variant={"flamingo-dark"}>
            Flamingo Dark
          </Text>
          <Text fw={700} variant={"orchid-dark"}>
            Orchid Dark
          </Text>
          <Text fw={700} variant={"sky-dark"}>
            Sky Dark
          </Text>
          <Box p={"xs"} bg={"white"}>
            <Text fw={700} variant={"night"}>
              Night
            </Text>
          </Box>
          <Text fw={700} variant={"white"}>
            White
          </Text>
          <Text fw={700} variant={"grey-100"}>
            Grey 100
          </Text>
          <Text fw={700} variant={"grey-200"}>
            Grey 200
          </Text>
          <Text fw={700} variant={"grey-300"}>
            Grey 300
          </Text>
          <Text fw={700} variant={"grey-400"}>
            Grey 400
          </Text>
          <Text fw={700} variant={"grey-500"}>
            Grey 500
          </Text>
          <Text fw={700} variant={"grey-600"}>
            Grey 600
          </Text>
          <Box p={"xs"} bg={"white"}>
            <Text fw={700} variant={"grey-700"}>
              Grey 700
            </Text>
          </Box>
          <Box p={"xs"} bg={"white"}>
            <Text fw={700} variant={"grey-800"}>
              Grey 800
            </Text>
          </Box>
          <Box p={"xs"} bg={"white"}>
            <Text fw={700} variant={"grey-900"}>
              Grey 900
            </Text>
          </Box>
        </Group>
      </Grid.Col>
    </Grid>
  </>
);
